import { render } from "./authLayout.vue?vue&type=template&id=92fb1fea&scoped=true"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"

import "./authLayout.vue?vue&type=style&index=0&id=92fb1fea&lang=scss&scoped=true"

import exportComponent from "F:\\work\\angren\\qabul_auniver\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92fb1fea"]])

export default __exports__